export const sha256 = async (sentence: string): Promise<string> => {
  // It doesn't need to worry for IE11's partial support
  // Because of IE isn't supported at this app.
  // Convert string to ArrayBuffer
  const buff = new Uint8Array(sentence.split('').map(c => c.charCodeAt(0))).buffer;

  // Calculate digest
  const digest: ArrayBuffer = await crypto.subtle.digest('SHA-256', buff);

  // Convert ArrayBuffer to hex string
  // (from: https://stackoverflow.com/a/40031979)
  const sha256ChunkArray: string[] = [];
  const intArray: Uint8Array = new Uint8Array(digest);
  intArray.forEach(n => {
    sha256ChunkArray.push(`00${n.toString(16)}`.slice(-2));
  });

  return sha256ChunkArray.join('');
};
